const ColliderDB = [
   /* {
        colliderId:'middleBox',
        displayCollider:'N',
    }*/
];

export default ColliderDB;
